import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { nth } from '../../../../utils';
import {
  pipe,
  groupBy,
  toPairs,
  map,
  prop,
  keys,
  filter,
//  addIndex,
  sortWith,
  ascend,
  descend
} from 'ramda';
import { generate } from 'shortid';
import { Header } from 'semantic-ui-react';
import { TeamCell } from '../../'; 


//const ixMap = addIndex(map);

// const QualifierMatrix = (props) => {
//   let matrix = [{}],
//       matchIx = 0;
  
//   const data = pipe(
//     groupBy(prop('attempt')),
//     map(round => groupBy(prop('teamId'), round)),
//     ixMap((round , roundIx) => {
//       matrix.push({});

//       // // TODO yks tiim j22b puudu
//       // if (roundIx === 0) {
//       //   matrix.push({});

//       //   ixMap((team, teamIx) => {
//       //     console.log( team );
//       //     matrix[0][teamIx + 1] = team[0].robotNumber;
//       //   }, round);

        

//       //   console.log( round );
//       // }

//       ixMap((team, teamIx) => {
//         console.log(roundIx);
//         // matrix[0][teamIx] = team[0].robotNumber;
//         // matrix[roundIx + 1][teamIx] = team[0].robotNumber;
//         matrix[roundIx + 1][teamIx + 1] = team[0].beginTime;
//       }, round);
       
//     })
//   )(props || []);

  
//   console.log(matrix);
// };

const QualifierTop = (props) => {

  let teamResults = [];

  pipe(
    groupBy(prop('teamId')),
    map(matches => {
      let sum = 0;

      for (let i = 0; i < matches.length; i +=1 ) {
        let result = matches[i].result;

        if (result) {
          sum += result;
        }
      }

      teamResults.push({
        robotName: matches[0].robotNumber,
        result: sum
      });
    })
  )(props.data || []);

  let resultArr = [];

  pipe(
    sortWith([
      descend(prop('result'))
    ]),
    map(({ robotName, result  }) => {
      resultArr.push(robotName + ': ' + result + ' points');
    })
  )(teamResults);

  return <div>{ resultArr.join(', ') }</div>;
};


const QualifierTable = (props) => {
  const data = pipe(
    sortWith([
      ascend(prop('beginTime')),
      ascend(prop('attempt'))
    ]),
    groupBy(prop('matchId')),
    toPairs,
    map(m => ({ matchId: m[0], teams: m[1] }))
  )(props.data || []);

  const teams = pipe(
    groupBy(prop('teamId')),
    keys
  )(props.data || []);

  const rounds = pipe(
    groupBy(prop('attempt')),
    keys
  )(props.data || []);

  return (
    <div>
      <Header as='h5'>
        Group: {props.title} ({teams.length} teams, {rounds.length} rounds)
      </Header>
      <QualifierTop data={props.data}/>
      <ReactTable
        className='-striped -highlight'
        data={data}
        columns={[
          nth,
          {
            Header: 'Begin',
            accessor: 'teams[0].beginTime',
            maxWidth: 60
          },
          {
            Header: 'End',
            id: 'endTime',
            accessor: 'teams[0].endTime',
            maxWidth: 50
          },
          {
            Header: 'Round #',
            accessor: 'teams[0].attempt',
            maxWidth: 70
          },
          {
            Header: 'Robot #1',
            accessor: 'teams[0].robotNumber',
            maxWidth: 240,
            Cell: ({ original: { teams: t }}) => {
              const i = 0;
              
              let val = t[i] ? t[i].robotNumber : '';

              if (val && t[i].result !== null && t[i].result !== undefined) {
                val += ' (' + t[i].result + ')';
              }

              return val;
            }
          },
          {
            Header: 'Robot #2',
            accessor: 'teams[1].robotNumber',
            maxWidth: 240,
            Cell: ({ original: { teams: t }}) => {
              const i = 1;
              
              let val = t[i] ? t[i].robotNumber : '';

              if (val && t[i].result !== null && t[i].result !== undefined) {
                val += ' (' + t[i].result + ')';
              }

              return val;
            }
          }
        ]}
        SubComponent={({ original: o }) =>
                      <TeamCell data={o} editable={props.editable}/>}
        pageSize={data.length}
        showPagination={false}
      />
      <br />
    </div>
  );
};

const RoundRobinTable = (props) => {
  const data = pipe(
    filter(t => t.matchType === 'QUALIFICATION'),
    groupBy(prop('group')),
    toPairs,
    map(t => ({ group: t[0], teams: t[1] }))
  )(props.data || []);

  //QualifierMatrix(data[0].teams);
  return (
    <div>
      <Header as='h4'>Qualifiers</Header>
      {map(group =>
           <QualifierTable
             key={generate()}
             title={group.group}
             editable={props.editable}
             data={group.teams}/>, data)}
    </div>
  );
};

export default RoundRobinTable;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/Tables/RoundRobinTable/index.js